/* eslint no-param-reassign: ["error", { "props": false }] */

export default {
  install: function install(Vue) {
    Vue.prototype.$breadcrumbEventBUS = new Vue();

    Vue.mixin({
      beforeCreate() {
        if (typeof this.$options.breadcrumb === 'function') {
          if (typeof this.$options.computed === 'undefined') {
            this.$options.computed = {};
          }
          this.$hasBreadcumb = true;
          this.$options.computed.$breadcrumb = this.$options.breadcrumb;
        }
      },
      created() {
        if (this.$hasBreadcumb) {
          this.$breadcrumbWatch();
        }
      },
      activated() {
        if (this.$hasBreadcumb) {
          this.$breadcrumbWatch();
        }
      },
      deactivated() {
        if (this.$hasBreadcumb) {
          this.$breadcrumbUnWatch();
        }
      },
      beforeDestroy() {
        if (this.$hasBreadcumb) {
          this.$breadcrumbUnWatch();
        }
      },
      methods: {
        $breadcrumbWatch() {
          if (this.$breadcrumbWatcher) return;
          this.$breadcrumbWatcher = this.$watch('$breadcrumb', (breadcrumb) => {
            const { name } = this.$route.matched.find(r => r.instances.default === this);
            if (name) {
              const { params } = this.$route;
              const { route } = this.$router.resolve({ name, params });
              this.$breadcrumbEventBUS.$emit('$breadcrumbChanged', { breadcrumb, route });
            }
          }, { immediate: true });
        },
        $breadcrumbUnWatch() {
          if (!this.$breadcrumbWatcher) return;
          this.$breadcrumbWatcher();
          this.$breadcrumbWatcher = undefined;
        },
      },
    });
  },
};
